import { useQuery } from "@tanstack/react-query";
import { fetchContent } from "@/lib/api";

export const contentKey = (key) => ["content", key];

export const useContent = (key, options = {}) => {
    return useQuery({
        queryKey: contentKey(key),
        queryFn: () => fetchContent(key),
        ...options,
    });
};
